module.exports = __webpack_public_path__ + "static/media/kslogo.95077344.png";